import axios from "axios";

export interface LocationDetail {
  name?: string;
  street?: string;
  district?: string;
  city?: string;
  county?: string;
  state?: string;
  country?: string;
  postcode?: string;
  extent?: number[];
  display_name?: string;
  latitude?: number;
  longitude?: number;
}

const BASE_URL = "https://photon.komoot.io";

export async function reverseGeocode(lat: number, lon: number): Promise<{ address: string; properties?: LocationDetail }> {
  try {
    const res = await axios.get(`${BASE_URL}/reverse`, {
      params: {
        lat: lat,
        lon: lon,
        lang: "en",
      },
    });

    const props = res.data?.features?.[0]?.properties as LocationDetail | undefined;

    const address = props
      ? [props.name, props.street, props.city, props.state /*, props.country*/]
        .filter(Boolean)
        .join(", ")
      : "";

    return { address, properties: props };
  } catch (error) {
    console.error("Error in reverse geocoding:", error);
    return { address: "" };
  }
}
